module.exports = __webpack_public_path__ + "img/message-pen.06955741.svg";